const A = ({href, className, children, download, style}) => (
    <a href={href} style={style ? style : {}} className={className} download={download ? true : false} target="_blank" rel="noopener noreferrer" >
        {children}
    </a>
)

export default A;